import React, { memo, useEffect, useState } from "react";

const Listv4 = memo((props) => {
  const [items, setItems] = useState([]);
  const [visible, setVisible] = useState(5);
  const [isHide, setIsHide] = useState(false);

  const showMoreItems = async () => {
    if (visible <= props.event.length) {
      setVisible(visible + 5);
    }
  };

  useEffect(() => {
    setItems(props.event);
    if (visible >= props.event.length) {
      setIsHide(true);
    }

    // eslint-disable-next-line
  }, [visible]);

  return (
    <>
      <div className="partner-list-row event-list-row grid row d-flex justify-center">
        {items.slice(0, visible).map((item, index) => (
          <div
            key={index}
            className="mb-10 grid col-lg-2 col-md-6"
          >
            <div className="partner-list potrait-event-container text-white size_box">
              <div className="partner-no">
                <span>{index + 1}</span>
              </div>
              <h4 className="mb-3">{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mb-10">
        <button
          onClick={showMoreItems}
          className={`bg-white hover:bg-blue-700 hover:text-white text-black font-bold py-2 px-4 btn-rsvp mb-10 ${
            isHide ? "hidden" : ""
          }`}
        >
          View More
        </button>
      </div>
    </>
  );
});

export default Listv4;
